import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Row, Col } from 'react-bootstrap';

import t from '../../../lib/I18n';

import BaseModal from '../../general/BaseModal';
import Icon from '../../general/Icon';
import AlertButton from '../AlertButton';

const SuccessModal = ({ isOneOffAlert, onClose, onCreateReturnAlert = false, showCreateReturnAlertOption, ...modalProps }) => {
    const baseClass = 'disruption-alerts-success-modal';

    const modalFooter = (
        <Fragment>
            <Row>
                <Col xs={12} className={`${baseClass}__footer-actions`}>
                    <Button
                        bsStyle="default"
                        onClick={onClose}
                        className="close action-btn action-btn--auto action-btn--secondary"
                    >
                        {t('button.text.close')}
                    </Button>
                    {showCreateReturnAlertOption && (
                        <AlertButton
                            onClick={onCreateReturnAlert}
                            text={t('disruptionAlerts.modals.success.createReturnAlert')}
                        />
                    )}
                </Col>
            </Row>
        </Fragment>
    );

    return (
        <BaseModal {...modalProps}
            className={`${baseClass} modal--xs text-center`}
            header={false}
            footer={modalFooter}
            disableBorderFooter
            hideContinue
        >
            <Icon className={`${baseClass}__tick`} icon="selected" />
            <h1 className={`${baseClass}__heading text-lg text-weight--semi-bold`}>
                {t('disruptionAlerts.modals.success.heading')}
            </h1>
            <p className="margin-bottom--0 padding--horiz-sm">
                {t(`disruptionAlerts.modals.success.message.${isOneOffAlert ? 'oneOff' : 'ongoing'}`)}
            </p>
        </BaseModal>
    );
};

SuccessModal.propTypes = {
    isOneOffAlert: PropTypes.bool.isRequired,
    modalProps: PropTypes.object,
    onClose: PropTypes.func.isRequired,
    onCreateReturnAlert: PropTypes.func.isRequired,
    showCreateReturnAlertOption: PropTypes.bool,
};

export default SuccessModal;



// WEBPACK FOOTER //
// ./src/components/disruptionAlert/modals/SuccessModal.js